import React from 'react'
import { Button, InputNumber, Modal, Typography } from 'antd'
import { ordersApi } from 'api/orders'
import { ITableOrder } from 'models/orders'
import { getOrderDeadline } from 'shared/utils/orders/getOrderDeadline'
import { showMessage } from 'shared/utils/showMessage'
import { showServerError } from 'shared/utils/showServerError'

interface IExtendDeadlineProps {
  order: ITableOrder
  onExtended: () => void
}

const MIN_HOURS = 1
const MAX_HOURS = 720

const kindTexts = {
  confirmation: 'подтверждение заказа',
  shipping: 'отправку заказа'
}

export const ExtendDeadline: React.FC<IExtendDeadlineProps> = ({
  order,
  onExtended
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [hours, setHours] = React.useState<number | null>(null)

  const deadline = getOrderDeadline(order)

  const isValid =
    hours !== null &&
    Number.isInteger(hours) &&
    hours >= MIN_HOURS &&
    hours <= MAX_HOURS

  const close = () => {
    setIsOpen(false)
    setHours(null)
  }

  const onSubmit = async () => {
    if (!isValid) return

    try {
      setIsLoading(true)
      await ordersApi.extendDeadline(order._id, { hours: hours as number })
      showMessage('success', `Срок продлён на ${hours} ч`, '')
      close()
      onExtended()
    } catch (e) {
      showServerError(e)
    } finally {
      setIsLoading(false)
    }
  }

  // Продлевать нечего, пока заказ не ждёт подтверждения или отправки
  if (!deadline) return null

  const kind = kindTexts[deadline.kind]
  const date = deadline.deadline.format('DD.MM.YYYY HH:mm')

  return (
    <>
      <Button size='small' onClick={() => setIsOpen(true)}>
        Продлить
      </Button>
      <Modal
        open={isOpen}
        centered
        width={420}
        title='Продление срока'
        okText='Продлить'
        cancelText='Отмена'
        okButtonProps={{ disabled: !isValid }}
        confirmLoading={isLoading}
        onOk={onSubmit}
        onCancel={close}
      >
        <Typography.Paragraph>
          {deadline.isOverdue
            ? `Срок на ${kind} истёк ${date}.`
            : `Срок на ${kind} — до ${date}.`}
        </Typography.Paragraph>
        <Typography.Text>На сколько часов продлить</Typography.Text>
        <InputNumber
          autoFocus
          value={hours}
          min={MIN_HOURS}
          max={MAX_HOURS}
          precision={0}
          placeholder={`от ${MIN_HOURS} до ${MAX_HOURS}`}
          style={{ width: '100%', marginTop: 8 }}
          onChange={setHours}
          onPressEnter={onSubmit}
        />
      </Modal>
    </>
  )
}
